// The app's canonical clock is Montréal's; the browser may sit elsewhere.
export const MONTREAL_TZ = "America/Montreal";

/**
 * Montréal's offset from UTC at `at`, in ms (local minus UTC, so -5 h is
 * -18 000 000). Volume buckets align to it, so day bars start at local midnight.
 */
export function montrealOffsetMs(at: number): number {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: MONTREAL_TZ,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(at);

  const value = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value);

  const local = Date.UTC(
    value("year"),
    value("month") - 1,
    value("day"),
    value("hour"),
    value("minute"),
    value("second"),
  );

  return local - Math.floor(at / 1000) * 1000;
}
